import {
    CasinoBannerPayload,
    FooterPayload,
    GlobalPayload,
    LandingPagePayload,
    OnboardingPagePayload,
    PokerPagePayload,
    PopupAppInstall,
    PopupManager,
    PopupNotification,
    PromoPage,
    NewsArticle,
    NewsPageBanner,
    SideMenuContentPayload,
    SportsPagePayload,
    StyledText,
    UserLevels, CasinoPagePayload, ContentModelName, GameListSection, AppLandingPagePayload
} from "./types";
import {ContenfulActions, ContentfulActionTypes} from "./ContentfulActions";


export enum ContentStatus {
    NONE, IN_PROGRESS, ERROR, SUCCESS
}
export interface ContentfulState {
    landingpage?: LandingPagePayload;
    appLandingPage?: AppLandingPagePayload;
    onboardingpage?: OnboardingPagePayload;
    sideMenuContent? : SideMenuContentPayload;
    global?: GlobalPayload;
    pokerPage?: PokerPagePayload;
    footer?: FooterPayload;
    isFetching: boolean;
    isFetchingMultiple?: boolean;
    error?: string;
    errorMultiple?: string;
    casinoBanner?: CasinoBannerPayload[];
    casinoPage?: CasinoPagePayload[];
    popupAppInstall?: PopupAppInstall;
    popupManager?: PopupManager;
    popupNotification?:PopupNotification;
    sportsPage?: SportsPagePayload;
    promoPage?: PromoPage;
    userLevels?: UserLevels;
    contentModelStatus? : {[key: string]: ContentStatus}
    newsArticle?: NewsArticle;
    newsPageBanner?: NewsPageBanner;
    styledText? : StyledText;
    /** NOTE: This state is for GameListSection contents for content type casino categories! The landing page will contains GameListSection's of it's own. */
    gameListSection?: GameListSection[];
}

const initialState : ContentfulState = {landingpage: undefined, isFetching: false, error: undefined, contentModelStatus : {}};

export function contentfulReducer (state = initialState, action: ContenfulActions) {
    let modelStatus = {...state.contentModelStatus ?? {}}
    switch (action.type) {
        case ContentfulActionTypes.FETCH_ENTRIES_REQUEST:
            modelStatus[action.contentModelName] = ContentStatus.IN_PROGRESS;
            return {...state, isFetching: true, contentModelStatus : modelStatus}
        case ContentfulActionTypes.FETCH_ENTRIES_SUCCESS:
            modelStatus[action.contentModelName] = ContentStatus.SUCCESS;
            return {...state, error: undefined, isFetching: false, [action.contentModelName]: action.payload,  contentModelStatus : modelStatus};
        case ContentfulActionTypes.FETCH_ENTRIES_ERROR:
            modelStatus[action.contentModelName] = ContentStatus.ERROR;
            return {...state, isFetching: false, error: action.error,  contentModelStatus : modelStatus}
        case ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_REQUEST:
            modelStatus[action.contentModelName] = ContentStatus.IN_PROGRESS;
            return {...state, isFetchingMultiple: true,  contentModelStatus : modelStatus}
        case ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_SUCCESS:
            modelStatus[action.contentModelName] = ContentStatus.SUCCESS;
            return {...state, isFetchingMultiple: false, [action.contentModelName]: action.payload,  contentModelStatus : modelStatus}
        case ContentfulActionTypes.FETCH_MULTIPLE_ENTRIES_ERROR:
            modelStatus[action.contentModelName] = ContentStatus.ERROR;
            return {...state, isFetchingMultiple: false, errorMultiple: action.error,  contentModelStatus : modelStatus}
        case ContentfulActionTypes.CHANGE_LNG:
            return {...state, landingpage: undefined, onboardingpage: undefined, global: undefined, pokerPage: undefined,  footer: undefined, infoPage: undefined,
                sportsPage: undefined, promoPage: undefined, userLevels: undefined, newsArticle: undefined, newsPageBanner: undefined}
        default:
            return state;
    }
}